import React from 'react';

import { EmptyState } from '@ergeon/core-components';
import { CursorArrowRaysIcon } from '@ergeon/icons/hero/outline';

export const NoCustomerSelectedEmptyState = () => (
  <div className="flex flex-col flex-grow justify-center items-center p-12 w-full">
    <EmptyState
      description="Select a customer from the left sidebar to see their details."
      icon={<CursorArrowRaysIcon />}
      title="No customer selected" />
  </div>
);
